import { render, staticRenderFns } from "./NewsEntry.vue?vue&type=template&id=19281f32&scoped=true&"
import script from "./NewsEntry.vue?vue&type=script&lang=js&"
export * from "./NewsEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewsEntry.vue?vue&type=style&index=0&id=19281f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19281f32",
  null
  
)

export default component.exports